



















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import Toast from '@/components/display/toast.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import { ProductAccessoryService } from '@/services/product-accessory-service';
import { TransceiversApi } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: {
		secondaryNav,
		Toast,
		infoTabs,
	},
})
export default class AccessoryView extends Vue {
	public accessory: any | null = null;
	public transceiver: any | null = null;
	public loading = true;
	public failure = false;
	private toast: Toast = new Toast();
	private accessoryApi: ProductAccessoryService = new ProductAccessoryService();
	private transceiversApi: TransceiversApi = new TransceiversApi();

	public getInstalledStatus() {
		return this.accessory.entityType && this.accessory.productId && this.accessory.entityId
			? 'Installed'
			: 'Uninstalled';
	}

	public pageTitle() {
		return `Accessory | ${this.accessory ? this.accessory.serialNumber : ''}`;
	}

	public async created() {
		const { accessoryId } = this.$route.params;
		this.loading = true;
		const accessoryResponse = await this.accessoryApi.getProductAccessory(
			parseInt(accessoryId, 10),
		);
		if (accessoryResponse.data) {
			this.accessory = accessoryResponse.data;
			try {
				const transceiverResponse = await this.transceiversApi.getTransceiverById(
					parseInt(this.accessory.transceiverId, 10),
				);
				this.transceiver = transceiverResponse.data;
			} catch (e) {
				const { errorMessage } = ApiUtils.handleApiError(e, 'Error getting transceiver data');
				this.toast.makeToast(errorMessage, 'Transceiver Error', 'danger');
				this.transceiver = null;
			}
		} else if (accessoryResponse.errorMessage) {
			this.failure = true;
			this.accessory = null;
			this.toast.makeToast(accessoryResponse.errorMessage, 'Accessory Error', 'danger');
		}

		this.loading = false;
	}
}
